<template>
  <div class="listitem flexsb">
    <div class="left">
      <img :src="item.imgUrl" alt />
    </div>
    <div class="center">
      <div class="top">
        <div class="flexfs mb-8">
          <!-- <p class="font16 fontbig mr-20">{{ item.name }}</p> -->
          <TooltipCard class="font16 fontbig mr-20" :text="item.name"/>
          <div class="store flexcenter mr-20">
            <span class="font12 mr-4">评分</span>
            <span class="font18">
              {{
              item.score.toString().indexOf(".") == -1
              ? item.score
              : item.score.toFixed(1)
              }}
            </span>
          </div>
          <div class="usage flexcenter">
            <span class="font12 mr-4">使用量</span>
            <span>{{ item.usedAmount }}</span>
          </div>
          <!-- 判断上架状态 -->
          <div class="btnState" v-if="item.status == 0">未上架</div>
          <div class="btnState btnUp" v-if="item.status == 1">已上架</div>
          <div class="btnState btnDown" v-if="item.status == 2">已下架</div>
          <div class="btnState btnWaitDown" v-if="item.status == 3">待下架</div>
          <div class="btnState btnDownExamine" v-if="item.status == 5">下架审核中</div>
        </div>
        <!-- <p class="introduce">{{ item.introduce }}</p> -->
        <Tooltip :disabled="disabled" :content="item.introduce" :max-width="500" transfer>
          <p class="introduce" ref="introduce">{{ item.introduce }}</p>
        </Tooltip>
      </div>
      <div class="btm flexfs provider">
        <span class="label">提供方：</span>
        <img v-if="item && item.logo" :src="item.logo" class="imgStyle" />
        <img v-else src="@/assets/img/user/company_default_logo.png" class="imgStyle" />
        <!-- <span class="ml-10">{{ item.oName }}</span> -->
        <TooltipCard class="ml-10" :text="item.oName" />
        <span class="ml-52 time">发布时间：{{ item.createTime }}</span>
      </div>
    </div>
    <!-- <div class="right">
      <div v-if="type == 'list'">
        <p class="font24 fontblue fontbig">{{ item.usedAmount }}</p>
        <p>使用量</p>
      </div>
      <div v-else>
        <Button shape="circle" type="primary" @click="immediateUse"
          >立即使用</Button
        >
      </div>
    </div>-->
    <!-- <bindApp v-if="showBind" @close="showBind = false"></bindApp> -->
  </div>
</template>

<script>
import bindApp from "@/views/manage/serve/components/BindApp";
export default {
  components: {
    bindApp
  },
  name: "",
  props: {
    item: Object,
    type: {
      type: String,
      default: "list"
    }
  },
  data() {
    return {
      showBind: false,
      useList: [],
      disabled: false
    };
  },
  mounted() {
    this.disabled = this.$refs.introduce.clientHeight >= this.$refs.introduce.scrollHeight;
  },
  methods: {
    link(e, path, id) {
      e.stopPropagation();
      this.$router.push({
        path: path,
        query: {
          companyId: this.item.oId
        }
      });
    },
    immediateUse() {
      this.showBind = true;
    }
  }
};
</script>

<style lang="scss">
.listitem {
  height: 230px;
  display: flex;
  justify-content: flex-start;
  .left {
    width: 324px;
    height: 182px;
    border-radius: 8px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }
  }
  .center {
    width: calc(100% - 324px);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 20px;
    .top {
      p {
        color: #67799c;
      }
      .introduce {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
        overflow: hidden;
      }
      .store {
        padding: 0 8px;
        height: 21px;
        background: #4f608b;
        border-radius: 0px 8px 0px 8px;
        color: #d6af76;
        text-align: center;
        font-size: 12px;
        flex-shrink: 0;
        white-space: nowrap;
      }
      .usage {
        white-space: nowrap;
        padding: 0 8px;
        height: 21px;
        background: #d6af76;
        border-radius: 0px 11px 0px 11px;
        color: #ffffff;
        flex-shrink: 0;
      }
      .btnState {
        width: 88px;
        height: 28px;
        background: rgba(145, 156, 175, 0.1);
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: auto;
        color: #919caf;
        flex-shrink: 0;
      }
      .btnUp {
        border: 1px solid rgb(140, 230, 176);
        color: rgb(140, 230, 176);
        background: rgb(237, 255, 243);
      }
      .btnDown {
        border: 1px solid rgb(237, 64, 20);
        color: rgb(237, 64, 20);
        background: rgb(255, 229, 230);
      }
      .btnWaitDown {
        border: 1px solid rgb(255, 176, 143);
        color: rgb(255, 176, 143);
        background: rgb(255, 239, 230);
      }
      .btnDownExamine {
        border: 1px solid rgb(109, 35, 3);
        color: rgb(109, 35, 3);
        background: rgb(255, 239, 230);
      }
    }
    .provider {
      .label, .imgStyle, .time {
        flex-shrink: 0;
      }
    }
    .btm {
      color: #919caf;
      img {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        overflow: hidden;
      }
    }
  }
  .right {
    width: 120px;
    text-align: center;
    color: #67799c;
  }
}
</style>
